import { JOBS_DELETED_EVENT } from "../../types";
import { request } from "../../utils";
import { locationRestJobsDelete } from "../../wp-api";
import { fetchStatus } from "..";
/**
 * Delete jobs by e.g. type. This is similar to a "Cancel" button.
 */ async function deleteJobs(params) {
    const response = await request({
        location: locationRestJobsDelete,
        params
    });
    document.dispatchEvent(new CustomEvent(JOBS_DELETED_EVENT, {
        detail: {
            params,
            response
        }
    }));
    await fetchStatus(true);
    return response;
}
export { deleteJobs };
